export default "__VITE_ASSET__ng1OWYlD2DWxm1PjJnipgQ__"